import React, { FunctionComponent } from "react";
import {Box, Typography, Link} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation, Trans} from "react-i18next";
import {links} from "/src/domain/shared/links";

const auditBanner = require("/src/assets/empty_audit.svg")


const EmptyAuditBanner: FunctionComponent = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    
    return <Box className={classes.bannerContainer}>
        <img className={classes.banner} src={auditBanner}  alt="audit banner"/>
        <Typography sx={{ mt: "1.5rem" }}>
            { t('noMatchingTracks') }
        </Typography>
        <Typography>
            <Trans 
                i18nKey={"possibleReasons"}
                components={[
                    <Link href={links.noInProtocolLink}>
                    </Link>
                ]}
            />
        </Typography>
    </Box>
}

const useStyles = makeStyles({
    bannerContainer: {
        margin: "1.5rem 1.5rem 0",
        textAlign: "center"
    },
    banner: {
        width: "100%",
        maxWidth: "20rem"
    }
})

export default EmptyAuditBanner